import React from 'react';
import { StyleSheet } from 'react-native';
import Svg, {
	Defs,
	FeBlend,
	FeColorMatrix,
	FeFlood,
	FeGaussianBlur,
	FeOffset,
	Filter,
	G,
	LinearGradient,
	Path,
	Stop,
} from 'react-native-svg';

import { useSvgId } from '../../../utils/hooks/useSvgId';

// Figma "Pill / Daily Missions" and "Pill / Free Chips", Mobile "Base" (907:142, 907:336): the
// #330E07 plate drawn three times under the same tight red drop shadow, which stacks into the
// rim glow, then a hairline border fading from #F46A0C at the top to #DA600E at the bottom.
// The artwork bleeds 5 past the 126x48 pill on every side so the glow is not clipped.
const BLEED = 5;
const WIDTH = 136.228;
const HEIGHT = 57.831;
const PLATE =
	'M15.8817 5H120.346C126.356 5 131.228 9.86694 131.228 15.8706V41.9603C131.228 47.964 126.356 52.831 120.346 52.831H15.8817C9.8719 52.831 5 47.964 5 41.9603V15.8706C5 9.86694 9.8719 5 15.8817 5Z';
const BORDER =
	'M15.8818 5.32617H120.346C126.176 5.32617 130.901 10.048 130.901 15.8711V41.96C130.901 47.7831 126.176 52.5049 120.346 52.5049H15.8818C10.052 52.5049 5.32617 47.7831 5.32617 41.96V15.8711C5.32617 10.048 10.052 5.32617 15.8818 5.32617Z';
const GLOW_LAYERS = [0, 1, 2];

const PillBase = () => {
	const glowId = useSvgId('pillGlow');
	const borderId = useSvgId('pillBorder');

	return (
		<Svg
			pointerEvents='none'
			style={styles.base}
			width={WIDTH}
			height={HEIGHT}
			viewBox={`0 0 ${WIDTH} ${HEIGHT}`}
			fill='none'
		>
			{GLOW_LAYERS.map(layer => (
				<G key={layer} filter={`url(#${glowId})`}>
					<Path fillRule='evenodd' clipRule='evenodd' d={PLATE} fill='#330E07' />
				</G>
			))}
			<Path d={BORDER} stroke={`url(#${borderId})`} strokeWidth={0.652902} />
			<Defs>
				<Filter id={glowId} x='0' y='0' width={WIDTH} height={HEIGHT} filterUnits='userSpaceOnUse'>
					<FeFlood floodOpacity='0' result='BackgroundImageFix' />
					<FeColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<FeOffset />
					<FeGaussianBlur stdDeviation='2.5' />
					<FeColorMatrix type='matrix' values='0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0' />
					<FeBlend mode='normal' in2='BackgroundImageFix' result='dropShadow' />
					<FeBlend mode='normal' in='SourceGraphic' in2='dropShadow' result='shape' />
				</Filter>
				<LinearGradient
					id={borderId}
					x1='68.1138'
					y1='52.831'
					x2='68.1138'
					y2='5'
					gradientUnits='userSpaceOnUse'
				>
					<Stop stopColor='#DA600E' />
					<Stop offset='1' stopColor='#F46A0C' />
				</LinearGradient>
			</Defs>
		</Svg>
	);
};

const styles = StyleSheet.create({
	base: {
		position: 'absolute',
		left: -BLEED,
		top: -BLEED,
	},
});

export default PillBase;
